export default __webpack_public_path__ + "static/api-doc-e6351beb955d245d2401acf50725353f.gif";